module.exports = __webpack_public_path__ + "media/images/icons/courses/3-6ca296f54b388565f40b0c5c8946b7d1.svg";